import { scaleFont } from "@utils";

/**
 * We provide a variety of `fontSize`
 * *Example*: `import  { fontSize } from '@kietpt2003/react-native-core-ui/themes'`
 */
export default {
  _8: scaleFont(8),
  _10: scaleFont(10),
  _11: scaleFont(11),
  _12: scaleFont(12),
  _13: scaleFont(13),
  _14: scaleFont(14),
  _16: scaleFont(16),
  _18: scaleFont(18),
  _20: scaleFont(20),
  _22: scaleFont(22),
  _24: scaleFont(24),
  _28: scaleFont(28),
  _30: scaleFont(30),
  _36: scaleFont(36),
  _48: scaleFont(48),
}